import PropTypes from 'prop-types';
import labelStyles from '@styles/labels.module.less';
import cn from 'classnames';
import s from './Metric.module.less';

const Metric = ({ value, label, className, labelClassName }) => (
  <div className={className}>
    <label className={cn(labelStyles.labelText, labelClassName)}>{label}</label>
    <span className={s.value}>{value}</span>
  </div>
);

Metric.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
};

Metric.defaultProps = {
  value: null,
  className: null,
  labelClassName: null,
};

export default Metric;
